/**
 * Sentry initialization
 */
import * as Sentry from '@sentry/react';
import { Routes } from 'react-router-dom';

import config from '../config';
import { Environments } from '../helpers/environments';

export const isSentryActivatedEnvironment = () => ([Environments.QA, Environments.PROD] as string[]).includes(config.appEnv);

export const initSentry = () => {
  if (isSentryActivatedEnvironment()) {
    Sentry.init({
      sendDefaultPii: true,
      release: config.sentry.release,
      dsn: config.sentry.dsn,
      integrations: [Sentry.browserTracingIntegration(), Sentry.reportingObserverIntegration()],
      environment: config.appEnv,
      tracesSampleRate: 0.2,
      tracePropagationTargets: [config.apiBaseUrl],
    });
    Sentry.setTag('tag', config.buildTag);
  }
};

export const SentryRoutes = isSentryActivatedEnvironment() ? Sentry.withSentryReactRouterV6Routing(Routes) : Routes;
